{
  "agb-to-accept-dialog": {
    "buttons": {
      "agree": "Agree",
      "deny-and-logout": "Decline and logout"
    },
    "text": {
      "agb": "Global Terms and Conditions (GTC)"
    }
  }
}
